import {QueryParamsEnum, QueryParamsForTaggingEnum} from 'presentation/constants';

export const clearBookingSearchParams = (currentSearchParams: URLSearchParams) => {
	currentSearchParams.delete(QueryParamsForTaggingEnum.SPECIALTY_CODE);
	currentSearchParams.delete(QueryParamsForTaggingEnum.SUB_SPECIALTY_CODE);
	currentSearchParams.delete(QueryParamsForTaggingEnum.SPECIALTY_NAME);
	currentSearchParams.delete(QueryParamsEnum.SEARCH_BY_LETTER);
	currentSearchParams.delete(QueryParamsEnum.SEARCH_QUERY);
	currentSearchParams.delete(QueryParamsEnum.STEP);
	currentSearchParams.delete(QueryParamsEnum.LOCALITY_DISTANCE);
	currentSearchParams.delete(QueryParamsEnum.AUTOCOMPLETE_QUERY);
	currentSearchParams.delete(QueryParamsEnum.SHIFT);
	currentSearchParams.delete(QueryParamsEnum.UF_CODE);
	currentSearchParams.delete(QueryParamsEnum.UF_NAME);
	currentSearchParams.delete(QueryParamsEnum.CITY_NAME);
	currentSearchParams.delete(QueryParamsEnum.DISABILITY);
	currentSearchParams.delete(QueryParamsForTaggingEnum.UNIT_NAME);
	currentSearchParams.delete(QueryParamsForTaggingEnum.UNIT_ADDRESS);
	currentSearchParams.delete(QueryParamsForTaggingEnum.UNIT_CODE);
	currentSearchParams.delete(QueryParamsForTaggingEnum.SHOW_BE_BORN_WELL_NOT_REGISTER);
};
